import React from "react";
import moment from "moment";
import { UNKNOWN_AUTHORIZATION_DATE } from "../../config";

export const Authorize = ({
  isQueryAuthorized,
  authorizedOn,
  onAuthorize,
  isAuthorizing,
}) => {
  return (
    <>
      {authorizedOn && (
        <p className="AuthorizedSync p-l-20">
          <i className="fa fa-check-circle" />
          {authorizedOn === UNKNOWN_AUTHORIZATION_DATE
            ? "Authorized"
            : `Authorized on ${moment(authorizedOn).format(
                "MM/DD/YYYY hh:mm A",
              )}`}
        </p>
      )}
      {!authorizedOn && !isQueryAuthorized && (
        <p className="AuthorizedSync p-l-20">
          <button
            className="new-blue-btn pull-left m-l-0"
            disabled={isAuthorizing}
            onClick={() => {
              if (!isAuthorizing) {
                onAuthorize();
              }
            }}
          >
            {isAuthorizing ? "Authorizing..." : "Authorize"}
          </button>
        </p>
      )}
    </>
  );
};
